export default __webpack_public_path__ + "static/media/vid-07.dc0a27f3.mp4";